import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
/* CORE */
import app from './routes/app'
/* ADMIN:CORE */
import users from './routes/Admin/Core/Users'
import userTypes from './routes/Admin/Core/User_types'
import smtpConfig from './routes/Admin/Core/Configs'
/* ADMIN:DEFINES */
import productConfig from './routes/Admin/Defines/Product_config'
import webformDepartments from './routes/Admin/Defines/Webform_departments'
/* ADMIN:APP */
import about from './routes/Admin/App/About'
import aboutCounters from './routes/Admin/App/About_counters'
import homePage from './routes/Admin/App/Home_page'
import blog from './routes/Admin/App/Blog'
import blogCategories from './routes/Admin/App/Blog_categories'
import carousel from './routes/Admin/App/Carousel'
import certificates from './routes/Admin/App/Certificates'
import corporatePolicies from './routes/Admin/App/Corporate_policies'
import corporatePoliciesCategories from './routes/Admin/App/Corporate_policies_categories'
import components from './routes/Admin/App/Components'
import configs from './routes/Admin/App/Configs'
import contacts from './routes/Admin/App/Contacts'
import contents from './routes/Admin/App/Contents'
import footerContacts from './routes/Admin/App/Footer_contacts'
import modLeads from './routes/Admin/App/Mod_leads'
import laboratory from './routes/Admin/App/Laboratory'
import laboratoryServices from './routes/Admin/App/Laboratory_services'
import laboratoryEducations from './routes/Admin/App/Laboratory_educations'
import laboratoryForms from './routes/Admin/App/Laboratory_forms'
import productCategories from './routes/Admin/App/Product_categories'
import products from './routes/Admin/App/Products'
import siteMenu from './routes/Admin/App/Site_menu'
import socialMedia from './routes/Admin/App/Socialmedia'
import translate from './routes/Admin/App/Translate'
import cacheParams from './routes/Admin/App/Cache_params'
import references from './routes/Admin/App/References'
import webforms from './routes/Admin/App/Webforms'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...app,
    ...configs,
    ...users,
    ...userTypes,
    ...siteMenu,
    ...about,
    ...aboutCounters,
    ...homePage,
    ...blog,
    ...blogCategories,
    ...carousel,
    ...contacts,
    ...components,
    ...certificates,
    ...corporatePolicies,
    ...corporatePoliciesCategories,
    ...contents,
    ...footerContacts,
    ...modLeads,
    ...laboratory,
    ...laboratoryServices,
    ...laboratoryEducations,
    ...laboratoryForms,
    ...products,
    ...productCategories,
    ...productConfig,
    ...webformDepartments,
    ...smtpConfig,
    ...socialMedia,
    ...translate,
    ...cacheParams,
    ...references,
    ...webforms,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
